var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['smiley-face', { bouncing: _vm.mood === 'smile' }],style:(_vm.bounceStyle)},[_c('div',{staticClass:"eye left"}),_c('div',{staticClass:"eye right"}),_c('div',{class:['smile', _vm.mood]})])
}
var staticRenderFns = []

export { render, staticRenderFns }